import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { AlertService } from "@modules/alert";
import { ConfirmActionModalComponent } from "src/app/components/dashboard/confirm-action-modal/confirm-action-modal/confirm-action-modal.component";
import { AiTokensApiService } from "../../services/ai-tokens-api.service";
import { AiModel } from "../../models/ai-model.model";
import { AiModelFormDialogComponent } from "../ai-model-form-dialog/ai-model-form-dialog.component";

@Component({
  selector: "app-ai-models-list",
  templateUrl: "./ai-models-list.component.html",
  styleUrls: ["./ai-models-list.component.scss"],
})
export class AiModelsListComponent implements OnInit {
  displayedColumns = [
    "provider",
    "modelId",
    "inputPrice",
    "outputPrice",
    "active",
    "actions",
  ];
  models: AiModel[] = [];
  loading = false;

  constructor(
    private api: AiTokensApiService,
    private dialog: MatDialog,
    private alertService: AlertService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.refresh();
  }

  refresh(): void {
    this.loading = true;
    this.api.listModels().subscribe({
      next: (rows) => {
        this.models = rows;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  openCreate(): void {
    const ref = this.dialog.open(AiModelFormDialogComponent, {
      width: "500px",
      data: { mode: "create" },
    });
    ref.afterClosed().subscribe((created) => {
      if (created) this.refresh();
    });
  }

  openEdit(model: AiModel): void {
    const ref = this.dialog.open(AiModelFormDialogComponent, {
      width: "500px",
      data: { mode: "edit", model },
    });
    ref.afterClosed().subscribe((updated) => {
      if (updated) this.refresh();
    });
  }

  toggleActive(model: AiModel): void {
    this.api
      .updateModel(model.id, { active: !model.active })
      .subscribe(() => this.refresh());
  }

  delete(model: AiModel): void {
    const dialogRef = this.dialog.open(ConfirmActionModalComponent, {
      data: {
        action: {
          text:
            this.translate.instant("GENERALS.DELETE") +
            " " +
            this.translate.instant("AI_TOKENS.AI_MODEL"),
          needs_confirmation: true,
        },
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) return;
      this.api.deleteModel(model.id).subscribe(() => {
        this.alertService.success(
          this.translate.instant("AI_TOKENS.MODEL_DELETED")
        );
        this.refresh();
      });
    });
  }

  centsToDollars(c: number): string {
    return "$" + (c / 100).toFixed(2);
  }
}
